import { dm_loai_lien_he } from "../models/response/category/dm_loai_lien_he";
import { apiClient } from "./apiClient";

export const LOAI_LIEN_HE_API_END_POINT = "loai-lien-he";

export const loaiLienHeApi = {
    select_by_coso: (dm_coso_id: number) => apiClient.get(`${LOAI_LIEN_HE_API_END_POINT}?dm_coso_id=${dm_coso_id}`),
    detail: (id: number) => apiClient.get(`${LOAI_LIEN_HE_API_END_POINT}/${id}`),
    insert: (payload: dm_loai_lien_he) => apiClient.post(LOAI_LIEN_HE_API_END_POINT, payload),
    update: (payload: dm_loai_lien_he) => apiClient.put(LOAI_LIEN_HE_API_END_POINT, payload),
    delete: (id: number) => apiClient.delete(`${LOAI_LIEN_HE_API_END_POINT}/${id}`)
}
